export class InitializeTransportGoodsState {
  static readonly type = '[TransportGoods] InitializeTransportGoodsState';
  constructor(public readonly organizationalUnitId: string) {}
}
